import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  zIndex: 4,
  display: 'flex',
  flexDirection: 'column',
  width: '205px',
  height: '100%',
  padding: '24px 8px',
  boxShadow: '1px 0 1px rgba(136, 151, 165, 0.2)',
}));

export const WrapperLinks = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Icon = styled('span')(({ theme}) => ({
  width: '24px',
  height: '24px',
  flexShrink: 0,
  transition: 'color ease-in-out 80ms',
  marginRight: '10px',
  color: theme.palette.text.secondary,
}));

export const StyledLinkItem = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '10px',
  borderRadius: '12px',
  transition: 'background-color ease-in-out 80ms, color ease-in-out 80ms',

  '&.active': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,

    '& > span': {
      color: theme.palette.primary.main,
    },

    Icon: {
      color: theme.palette.primary.main,
    },
  },

  '&:hover': {
    backgroundColor: theme.palette.grey[600],
  },

  '&:not(:last-child)': {
    marginBottom: '10px',
  }
}));
